import {
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';

// SESSION-admin-ptg-003 — `.dropzone` organism. Drag-drop OR click-to-pick.
// Content-projection for the inline copy slot lets callers override the
// strong/hint labels. Emits selected files via `filesDropped`.
@Component({
    selector: 'app-dropzone',
    templateUrl: './dropzone.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class DropzoneComponent {
    @Input() multiple = true;
    @Input() accept: string | null = null;
    @Input() strong = 'Drag files here, or click to upload';
    @Input() hint = 'PDF, video, slides or images · up to 200 MB each';

    @Output() filesDropped = new EventEmitter<File[]>();

    @ViewChild('input', { static: true }) input!: ElementRef<HTMLInputElement>;

    @HostBinding('class.dropzone') dropzoneClass = true;
    @HostBinding('class.drag') dragOver = false;

    @HostListener('click')
    onClick(): void {
        this.input.nativeElement.click();
    }

    @HostListener('dragenter', ['$event'])
    @HostListener('dragover', ['$event'])
    onDragOver(ev: DragEvent): void {
        ev.preventDefault();
        this.dragOver = true;
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave(ev: DragEvent): void {
        ev.preventDefault();
        this.dragOver = false;
    }

    @HostListener('drop', ['$event'])
    onDrop(ev: DragEvent): void {
        ev.preventDefault();
        this.dragOver = false;
        const files = ev.dataTransfer?.files;
        if (!files || files.length === 0) {
            return;
        }
        this.emit(Array.from(files));
    }

    onInputChange(ev: Event): void {
        const target = ev.target as HTMLInputElement;
        const files = target.files;
        if (!files || files.length === 0) {
            return;
        }
        this.emit(Array.from(files));
        // reset so picking the same file twice re-fires.
        target.value = '';
    }

    private emit(files: File[]): void {
        const filtered = this.multiple ? files : files.slice(0, 1);
        this.filesDropped.emit(filtered);
    }
}
